import { useI18n } from "@/lib/i18n";

export default function LanguageToggle({ testPrefix = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div
      role="tablist"
      data-testid={`${testPrefix}lang-toggle`}
      className="inline-flex bg-slate-100 rounded-sm p-0.5 border border-slate-200"
    >
      {["en", "sv"].map((code) => {
        const active = lang === code;
        return (
          <button
            key={code}
            role="tab"
            aria-selected={active}
            data-testid={`${testPrefix}lang-${code}`}
            onClick={() => setLang(code)}
            className={`px-2.5 py-1 text-[11px] font-semibold tracking-widest uppercase rounded-sm transition-colors ${
              active ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-800"
            }`}
          >
            {code}
          </button>
        );
      })}
    </div>
  );
}
